module.exports = global.WebSocket || global.MozWebSocket;



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/transport/browser/websocket.js
// module id = 20
// module chunks = 0